import React from 'react';
import { Link } from 'react-router-dom';

const HelpHeader = () => (
  <header className="help-hero">
    <div className="help-hero__text">
      <h1 className="help-hero__title">왓퀴즈 고객센터</h1>
      <p className="help-hero__desc">새 기능과 공지, 왓퀴즈 소식을 모아 두었어요.</p>
    </div>
    <div className="help-hero__links">
      <a href="/docs/whatquiz-manual.pdf" target="_blank" rel="noopener noreferrer" className="help-hero__link">
        사용 매뉴얼 PDF
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M12 4v12" />
          <path d="M7 11l5 5 5-5" />
          <path d="M5 20h14" />
        </svg>
      </a>
      <Link to="/support" className="help-hero__link">
        사용 가이드·자주 묻는 질문
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </Link>
    </div>
  </header>
);

export default HelpHeader;
